import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  useNavigate,
  Routes,
} from "react-router-dom";
import { Security, LoginCallback } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import Home from "./pages/Home/Home";
import { oktaAuthConfig } from "./config";
import "./App.scss";
import NavBar from "./components/NavBar/NavBar";
import { RequiredAuth } from "./components/SecureRoute";
import Loading from "./components/Loading";

function App(): React.JSX.Element {
  const oktaAuth = new OktaAuth(oktaAuthConfig);
  const navigate = useNavigate();

  // use hooks to set the document.title; can be done on page components to change title for those pages
  useEffect(() => {
    document.title = "Franchise Availability Report";
  }, []);

  const restoreOriginalUri = (_oktaAuth: any, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <NavBar />
      <Routes>
        <Route
          path="/implicit/callback"
          element={<LoginCallback loadingElement={<Loading />} />}
        />
        <Route path="/" element={<RequiredAuth />}>
          <Route path="" element={<Home />} />
        </Route>
      </Routes>
    </Security>
  );
}

export default function AppWithRouterAccess(): React.JSX.Element {
  return (
    <Router>
      <App />
    </Router>
  );
}
